export function hasNativeJSBridge(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const webkitHandlers = (
    window as Window & {
      webkit?: {
        messageHandlers?: {
          jsb?: unknown;
          bridgeReady?: unknown;
        };
      };
    }
  ).webkit?.messageHandlers;

  return !!(webkitHandlers?.jsb && webkitHandlers?.bridgeReady);
}
